import { createContext } from 'react';
const AccordionContext = /*#__PURE__*/createContext({
  variant: null,
  numbered: null
});
export default AccordionContext;